var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
const DEFAULT_EXTERNAL_LINK_MATCHER = /[a-zA-Z0-9]*:(\/\/)?[^\s]*/g;
export const DefaultLink = (_a) => {
    var { to } = _a, rest = __rest(_a, ["to"]);
    return _jsx("a", Object.assign({ href: to }, rest));
};
const defaultComponentConfig = {
    link: {
        externalMatcher: DEFAULT_EXTERNAL_LINK_MATCHER,
        navigate: (url) => {
            window.location.href = url;
        },
        internalLinkComponent: DefaultLink,
        externalLinkComponent: DefaultLink,
    },
    modal: {
        appElement: undefined,
    },
};
export const ComponentConfigContext = createContext(defaultComponentConfig);
export const useComponentConfig = () => useContext(ComponentConfigContext);
export const ComponentConfigProvider = ({ config: configParam, children }) => {
    const config = useMemo(() => (Object.assign(Object.assign(Object.assign({}, defaultComponentConfig), configParam), { link: Object.assign(Object.assign({}, defaultComponentConfig.link), configParam.link) })), []);
    return (_jsx(ComponentConfigContext.Provider, Object.assign({ value: config }, { children: children })));
};
